import React from 'react';
import { payRateModStyles } from './PayRateMod.styles';
import { PayRateType } from './PayRateType';
import { Divider, Grid } from '@mui/material';
import { PayFactor } from './PayFactor/PayFactor';
import { AdditionalCompensation } from './AddCompensation/AdditionalCompensation';
import { useSelector } from 'react-redux';
import { selectExpandedModsDialog, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { PayRateGwwMod } from './PayRateGww';
import { PerDiemRates } from '../../CommonComponents/PerDiemRates';

export const PayRateMod = () => {
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { classes } = payRateModStyles({ isExpanded });
  const isModEdit = useSelector(selectIsEditMod);
  return (
    <Grid>
      <PayRateType isExpanded={isExpanded} isModEdit={isModEdit} />
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <PayFactor isExpanded={isExpanded} isModEdit={isModEdit} />
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <AdditionalCompensation isExpanded={isExpanded} isModEdit={isModEdit} />
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <PerDiemRates isExpanded={isExpanded} isModEdit={isModEdit} />
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <PayRateGwwMod isExpanded={isExpanded} isModEdit={isModEdit} />
    </Grid>
  );
};
